import { RadioGroup } from "@headlessui/react";
import PropTypes from "prop-types";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

const frequencies = [
    { value: "on", label: "On" },
    { value: "off", label: "Off" },
];

export default function ToggleComponent(props) {

    return (
        <RadioGroup
            value={props.isEnabled ? "on" : "off"}
            onChange={props.onChange}
            className="inline-flex items-center justify-center rounded-full bg-gray-100 ring-1 ring-inset ring-gray-200  sm:space-x-4 sm:p-1 text-center font-semibold leading-5 text-xs"
        >
            {frequencies.map((option) => (
                <RadioGroup.Option
                    key={option.value}
                    value={option.value}
                    className={({ checked }) =>
                        classNames(
                            checked
                                ? option.value === "on"
                                    ? "bg-green-700 text-white"
                                    : "bg-red-700 text-white"
                                : "text-gray-600 hover:text-gray-800",
                            // Compact on mobile, normal on desktop
                            "rounded-full cursor-pointer px-3.5 py-0.5 text-[11px] sm:px-4 sm:py-1.5 sm:text-xs transition-colors duration-150"
                        )
                    }
                >
                    {option.label}
                </RadioGroup.Option>
            ))}
        </RadioGroup>
    );
}


ToggleComponent.propTypes = {
    isEnabled: PropTypes.bool,
    onChange: PropTypes.func,
}
